module.exports = __webpack_public_path__ + "img/icon-profile.b3f17f29.png";